(function () {
  'use strict';

  angular
    .module('itecAdministracio.entitats.main.logos')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.logos', {
        url: '/logos',
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }
            }
          },
          'content@entitats.main.submain': {
            templateUrl: 'entitats/main/logos/logos.tpl.html',
            controller: 'EntitatsMainLogosCtrl',
            controllerAs: 'ctrl',
            resolve: {
              logosData: function(LogoFactory, $stateParams){
                return LogoFactory.getAll($stateParams.idEntitat);
              }
            }
          }
        },
        breadcrumb: 'DEFAULT_LOGOS'
      });
  }
}());
